module.exports = __webpack_public_path__ + "img/1512013782.afbe4021.jpg";